import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * White rounded sheet that the brand hero collapses over. Neutral dark ink.
 * Height is controlled by the caller (e.g. `flex-1`) so the scroll column can
 * guarantee enough room for the header to fully collapse even on short forms.
 */
export function ApplyFormSheet({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'relative max-w-full sm:max-w-md sm:mx-auto bg-white px-5 pb-10 pt-5 text-[#16171a]',
        className
      )}
    >
      {children}
    </div>
  );
}
